import { render, staticRenderFns } from "./UserAuthentication.vue?vue&type=template&id=873365b2&"
import script from "./UserAuthentication.vue?vue&type=script&lang=ts&"
export * from "./UserAuthentication.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports